export const REQUEST_ITEM_SEARCH_DATA = 'REQUEST_ITEM_SEARCH_DATA';
export const RECEIVE_ITEM_SEARCH_DATA = 'RECEIVE_ITEM_SEARCH_DATA';
export const ERROR_ITEM_SEARCH_DATA = 'ERROR_ITEM_SEARCH_DATA';
export const RESET_ITEM_SEARCH_DATA = 'RESET_ITEM_SEARCH_DATA';

export const requestItemSearchData = (data) => (
  {
    type: REQUEST_ITEM_SEARCH_DATA,
    data
  });

export const receiveItemSearchData = (data) => (
  {
    type: RECEIVE_ITEM_SEARCH_DATA,
    data
  });

export const errorItemSearchData = (data) => (
  {
    type: ERROR_ITEM_SEARCH_DATA,
    data
  });

export const resetItemSearchData = (data) => (
  {
    type: RESET_ITEM_SEARCH_DATA,
    data
  });
